import * as actionTypes from 'apps/instagram/constants/instagramReduxActionTypes'
import { parseAccounts } from 'apps/instagram/models/adapter'
import { getAccountsFetched } from 'apps/instagram/selectors/instagramSelectors'
import { IAsyncThunkAction } from 'common/core/interfaces/actions'
import { handleCatch } from 'shared/api/lib/errors/handlers'
import { settingsApi } from 'shared/api/requests/settings'
import { createAsyncAction } from 'shared/lib/redux'

export const fetchConnectedInstagramAccounts = createAsyncAction(
  'instagram/fetchConnectedInstagramAccounts',
  async (_, { getState }) => {
    const isAccountsFetched = getAccountsFetched(getState())

    if (isAccountsFetched) {
      return []
    }

    const { data } = await settingsApi.instagram.getConnectedInstagramAccount()
    return parseAccounts(data.accounts)
  },
)

export const toggleInstagramChannel = (value: boolean): IAsyncThunkAction => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.TOGGLE_INSTAGRAM_CHANNEL_REQUEST })

      await settingsApi.toggleInstagramChannel({ body: { value } })

      dispatch({ type: actionTypes.TOGGLE_INSTAGRAM_CHANNEL_RESPONSE, value })
    } catch (error) {
      dispatch({ type: actionTypes.TOGGLE_INSTAGRAM_CHANNEL_ERROR })
      handleCatch(error)
    }
  }
}
